// atomConstants.ts

import {
  AdConfigPlacement,
  AdServer,
  AfsConfig,
  AfsPlacement,
  InitialState,
  PlacementStatusMetric
} from '@schibsted-nmp/advertising-shared';
import { $placementStatusMetrics } from '@client/core/atoms/metrics';

import {
  $config,
  $gamTargetingAtom,
  $ppidAtom,
  getEmptyOrPersistedPPID
} from './config';
import { $placementsAtom } from './placements';
import { $afsAtom } from './afs';

export enum AtomChannels {
  Podlet = 'advertising-podlet'
}

export enum AtomTopics {
  PPID = 'ppid',
  Glimr = 'glimr',
  Cycle = 'cycle',
  GamTargeting = 'gamTargeting',
  PrebidLoadedList = 'prebidLoadedList',
  Keywords = 'keywords',
  AdContainerMap = 'adContainerMap',
  Placements = 'placements',
  Config = 'config',
  Afs = 'afs',
  PlacementStatusMetrics = 'placementStatusMetrics'
}

export const setInitialGlobalAtoms = (initialState: InitialState) => {
  const gamTargeting = initialState?.config?.adServer?.gam?.targeting || [];

  $config.set(initialState?.config || {});
  $ppidAtom.set(getEmptyOrPersistedPPID());
  $gamTargetingAtom.set(gamTargeting);
  $placementsAtom.set(
    initialState?.config?.placements || ([] as AdConfigPlacement[])
  );
  $afsAtom.set({
    config: initialState?.config?.adServer.afs || ({} as AfsConfig),
    placements: initialState?.config?.placements.filter(
      (placement) => placement.adServer.type === AdServer.AFS
    ) as AfsPlacement[]
  });
  $placementStatusMetrics.set(
    initialState?.config?.placements?.map((placement) => {
      const placementStatus: PlacementStatusMetric = {
        placementId: placement.placementId,
        statuses: ['expected']
      };
      return placementStatus;
    }) || []
  );
};
